import { buildR2AssetsImageUrl } from "@saas/shared/lib/image-url-builder";
import {
	TINY_DESK_BACKING_IMAGE,
	TINY_DESK_KEYBOARD_IMAGE,
	type TinyDeskQualityId,
} from "./tiny-desk-preset";

export interface TinyDeskShowcaseClip {
	id: string;
	quality: TinyDeskQualityId;
	orientation: "portrait";
	onSite: boolean;
	duration: number;
	videoUrl: string;
	previewVideoUrl: string;
	poster: string;
	hasAudio: boolean;
	inputImages: string[];
}

const R2_BASE = "home/showcase/tiny-desk";

/**
 * 两条样片均由本页工作台生成，已核对 metadata.page 与扣费。
 * 工作台与下方样片区共用同一份 720p 文件；v=2 避免上线前占位检查的负缓存。
 */
export const tinyDeskShowcaseClips: TinyDeskShowcaseClip[] = [
	{ id: "band-one", lead: "lead-one" },
	{ id: "band-two", lead: "lead-two" },
].map(({ id, lead }) => {
	const videoUrl = buildR2AssetsImageUrl(`${R2_BASE}/clips/${id}-720p.mp4?v=2`);
	return {
		id,
		quality: "hd",
		orientation: "portrait",
		onSite: true,
		duration: 11.542,
		videoUrl,
		previewVideoUrl: videoUrl,
		poster: buildR2AssetsImageUrl(`${R2_BASE}/posters/${id}-720p.jpg?v=2`),
		hasAudio: true,
		inputImages: [
			buildR2AssetsImageUrl(`${R2_BASE}/refs/${lead}.jpg`),
			TINY_DESK_KEYBOARD_IMAGE,
			TINY_DESK_BACKING_IMAGE,
		],
	};
});

/** 两条本页 HD 样片的正式上传日期。 */
export const TINY_DESK_SHOWCASE_UPLOADED_AT = "2026-10-28T13:20:42+00:00";
